import React, { Fragment, useEffect, useState } from "react";
import img1 from "../../../images/consulting/innovation-consulting-img1.webp";
import img2 from "../../../images/consulting/02.jpg";
import img3 from "../../../images/consulting/innovation-consulting-img2.webp";
import img4 from "../../../images/consulting/04.jpg";

const services = [
  "Digital Product Engineering",
  "Custom Software Development",
  "Enterprise Automation",
  "Dedicated Teams",
  "Rapid Prototyping",
  "Web Development",
];

const InnovationConsulting: React.FC = () => {
   
  return (
    <Fragment>
     <div className="container">
                        <h2 className="details-content-title mb-15">
                    Innovation Consulting Agency
                </h2>

                <p>
                   We assist companies in looking for new technology-driven opportunities by addressing operational efficiency, expansion, technology, and business management challenges. Our approach to innovation consulting combines best practices in business analysis, market research, product delivery, and future growth strategy development. Brain MAchine.Ai's technology and business consultants provide an unmatched breadth of support to ensure the top-grade quality of your solutions and make them genuinely valuable for your company.
                </p>

     </div>
      <div className="why-section ">
  <div className="container mb-25">
    <div className="text-center mb-5" data-aos="fade-up">
      <h2 className="section-title" style={{color: 'white'}}>Why Brain Machine.AI</h2>
    </div>
    
    <div className="row g-4">
      {/* Benefit 1 */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="0">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt">Increase speed to market</h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#a4c639'}}>01</span>
          </div>
        </div>
      </div>

      {/* Benefit 2 */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt">Reduce development cost</h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#ffc107'}}>02</span>
          </div>
        </div>
      </div>

      {/* Benefit 3 */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt">Assure information security</h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#9c27b0'}}>03</span>
          </div>
        </div>
      </div>

      {/* Benefit 4 */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt">Get high-quality software</h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#f44336'}}>04</span>
          </div>
        </div>
      </div>

      {/* Benefit 5 */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt">Scale team up and down</h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#2196f3'}}>05</span>
          </div>
        </div>
      </div>

      {/* Link to Framework */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt" >
            Exclusive Delivery Framework
          </h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#2196f3'}}>06</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    <section className="innovation-process ">
      <div className="container">
        <h2 className="text-center fw-bold mt-60 mb-60">
          Innovation consulting process:
        </h2>

        <div className="box row justify-content-center align-items-center g-5">
          {/* Step 1 */}
          <div className="col-lg-4 col-md-6 text-center">
            <div className="process-item yellow mx-auto">
              <span className="step-number">01</span>
              <div className="process-circle">
                <div className="icon">?</div>
                <h5 className="mt-3 fw-semibold">Clarification call</h5>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="col-lg-4 col-md-6 text-center">
            <div className="process-item green mx-auto">
              <span className="step-number">02</span>
              <div className="process-circle">
                <div className="icon">📋</div>
                <h5 className="mt-3 fw-semibold">
                  Pre-discovery <br /> workshop
                </h5>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="col-lg-4 col-md-6 text-center">
            <div className="process-item blue mx-auto">
              <span className="step-number">03</span>
              <div className="process-circle">
                <div className="icon">💡</div>
                <h5 className="mt-3 fw-semibold">
                  Discovery <br /> phase
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      <section className="clarification-call py-5">
      <div className="container">
        <div className="row align-items-center pt-5">
          
          {/* LEFT CONTENT */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="content-wrapper">
              <h2 className="fw-bold mb-4 mt-55">Clarification call</h2>

              <p className=" callp">
                <strong>Our Company</strong> provides a free, no-commitment
                starting point of project delivery, which clarifies our
                customer’s needs. It’s a crucial activity if you realize that
                something needs to be done but don’t know exactly what that is.
                Our very special SWAT squad, a team of consultants who can
                process the information quickly and efficiently, is ready to
                answer the questions during the call and navigate you through
                all the stages of the upcoming project.
              </p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6">
            <div className="image-wrapper">
              <img
                src={img1}
                alt="Clarification call"
                  style={{ height: "280px", borderRadius: "8px" }}
              />
            </div>
          </div>

        </div>

        {/* BOTTOM SECTION */}
        <div className="row mt-45 g-5">
          <div className="col-lg-6 ">
            <img
              src={img2}
              alt="Discussion"
              className="img-fluid rounded"
            />
          </div>

          <div className="col-lg-6">
            <h5 className="fw-semibold mb-3">
              The call explores the client’s business overview and clarifies
              their needs, including:
            </h5>

            <ul className="custom-list">
              <li>Challenges and opportunities</li>
              <li>Delivery deadlines and time to market</li>
              <li>Goals and objectives</li>
              <li>Desired results and potential solutions</li>
              <li>Preferences toward a particular stack of technology and desired cooperation model</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

  <div className="container pt-5">
      {/* Section Title */}
      <div className="text-center mb-5">
        <h2>Our contribution:</h2>
      </div>

      {/* Contribution Items */}
      <div className="row text-center pt-45">
        <div className="col-md-4 mb-4">
          <div className="p-3">
            {/* Placeholder for icon */}
            <div className="mb-3" style={{ fontSize: 50, color: "#FFC107" }}>
              🔍
            </div>
            <h5>Estimate innovation opportunities</h5>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="p-3">
            {/* Placeholder for icon */}
            <div className="mb-3" style={{ fontSize: 50, color: "#8BC34A" }}>
              📋
            </div>
            <h5>Validate technology change</h5>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="p-3">
            {/* Placeholder for icon */}
            <div className="mb-3" style={{ fontSize: 50, color: "#90CAF9" }}>
              🗄️
            </div>
            <h5>Align the stakeholders</h5>
          </div>
        </div>
      </div>
    </div>


     <section className="clarification-call py-5">
      <div className="container">
        <div className="row align-items-center pt-5">
          
          {/* LEFT CONTENT */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="content-wrapper">
              <h2 className="fw-bold mb-4 mt-55">Pre-discovery workshop</h2>

             
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6">
            <div className="image-wrapper Pre-dis">
             <p>
                For those who want to set their project on the right track from the very beginning, we introduced a Pre-discovery Workshop—a phase of a thorough, profound analysis. In three to five days of an onsite, tailored workshop, our team delves into your business issues and provides the top-level vision of handling them.
              </p>
            </div>
          </div>

        </div>

        {/* BOTTOM SECTION */}
        <div className="row mt-45 g-5">
          <div className="col-lg-6 pt-45">
            <h5 className=" mb-3">
             The pre-discovery workshop results in clearly formulated concepts:
            </h5>

            <ul className="customs-list d-flex flex-wrap p-0 m-0  ">
              <li className="flex-half">Communication plan</li>
              <li className="flex-half">Architecture overview</li>
              <li className="flex-half">Roadmap for further phases</li>
              <li className="flex-half">UI/UX concept</li>
              <li className="flex-half">Vision & scope</li>
              <li className="flex-half">Project charter</li>
            </ul>
          </div>
          <div className="col-lg-6 ">
            <img
              src={img3}
              alt="Discussion"
              className="img-fluid rounded"
            />
          </div>
        </div>
      </div>
    </section>

      <section className="clarification-call pb-5">
      <div className="container">
        <div className="row align-items-center pt-5">
          
          {/* LEFT CONTENT */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="content-wrapper">
              <h2 className="fw-bold mb-4 mt-55">Discovery Phase</h2>

             
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6">
            <div className="image-wrapper Pre-dis">
             <p>       
              Discovery Phase is an intensive research period undertaken at the very start of a digital project by a discovery team that includes a Business Analyst, Solution Architect, UI/UX Specialist, and Project Manager.
              </p>
            </div>
          </div>

        </div>

        {/* BOTTOM SECTION */}
        <div className="row mt-45 g-5">
          <div className="col-lg-6 ">
            <h5 className=" mb-3">
             During the discovery phase, our team:
            </h5>
            <ul className="customs-list d-flex flex-wrap p-0 m-0  ">
              <li className="flex-half">Explores and suggests possible technical solutions</li>
              <li className="flex-half">Recommends a workable solution architecture and technical stack</li>
              <li className="flex-half">Works closely with you to validate the approach, ballpark costs and benefits</li>
              <li className="flex-half">Creates an MVP (Minimum Viable Product)</li>
            </ul>
            <p>
                The recommended change strategy will have clear qualitative outcomes, pros and cons, and a comparison with alternative approaches. Our experts work closely with the client to prepare an MVP for lowering risks and creating a faster validation of the approach.
            </p>
          </div>
          <div className="col-lg-6 ">
            <img
              src={img4}
              alt="Discussion"
              className="img-fluid rounded"
            />
          </div>
        </div>
      </div>
    </section>

     <section className="services-alt py-5">
      <div className="container">
        {/* Header */}
        <div className="row mb-5">
          <div className="col-lg-6">
            <h2 className="services-alt-title mb-25">Services we offer</h2>
            <p className="services-alt-subtitle mb-25">
              We help organizations design, build, and scale digital solutions
              through structured engineering and consulting excellence.
            </p>
          </div>
        </div>

        {/* List */}
        <div className="row">
          <div className="col-lg-10">
            {services.map((service, index) => (
              <div className="service-row" key={index}>
                <div className="service-number">
                  {(index + 1).toString().padStart(2, "0")}
                </div>

                <div className="service-text">
                  <h5>{service}</h5>
                  <p>
                    Strategy-driven delivery focused on performance, security,
                    and long-term scalability.
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    </Fragment>
  );
};

export default InnovationConsulting;